/** API values for billing transaction types (bulk sync / filters). */
export const TRANSACTION_TYPE_VALUES = [
  "incorporation",
  "foreign-company",
  "business-name",
  "building-society",
  "reservation",
  "annual-returns",
  "statemen-of-business-continuity",
  "continuous-filing",
  "amalgamation",
  "re-registration",
  "amendments",
  "restoration",
  "dispensation",
  "data-correction",
  "data-correction-document-regeneration",
  "legal-documents",
  "legal-documents-search",
  "legal-documents-certification",
  "record-search",
  "certification",
  "insolvency",
  "INSOLVENCY_REGISTRATION",
  "creditor-winding-up",
  "court-order-winding-up",
  "final-report-notice",
  "dispute-resolution",
  "reinstatement",
  "copyright-registration",
  "obrs",
  "name reservation",
] as const;

export type TransactionTypeValue = (typeof TRANSACTION_TYPE_VALUES)[number];

export type TransactionTypeOption = {
  value: TransactionTypeValue;
  text: string;
};

function labelForTransactionType(value: string) {
  const spaced = value.replaceAll("-", " ").replaceAll("_", " ");
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}

export const TRANSACTION_TYPE_OPTIONS: TransactionTypeOption[] = TRANSACTION_TYPE_VALUES.map(
  (value) => ({ value, text: labelForTransactionType(value) })
);
